<template>
    <div>
     <b-field label="Mobile phone number to notify" :type="type" :message="message">
       <b-input v-model="phone" v-mask="'###-###-####'" @input="validate" />
     </b-field>
     <div class="has-text-right">
      <b-button  type="is-primary" @click="save">SAVE</b-button>
      <b-button class="ml-2" @click="$emit('cancel','phone')">CANCEL</b-button>
     </div>
    </div>
   </template>
   <script>
       export default {
         name: "Mobile",
         components: {},
         data() {
           return {
               type : null,
               message : null,
               phone : null,
           }
         },
         methods:{
            validate() {
              let isValid = false;
              if(this.phone && this.phone.length == 12){
                this.type = null;
                this.message = null;
                isValid = true;
              } else {
                this.type = 'is-danger';
                this.message = 'Please enter valid mobile phone number.';
                isValid = false;
              }
              return isValid;
            },
            save() {
                let isValid = this.validate();
                if(isValid) {
                    this.$emit('savePhone',this.phone);
                }
            },
         },
       }
     </script>
   
   <style scoped>
   .minmaxmobile{
     width: 460px;
     max-width: 100%;
   }
 </style>